import React from "react";
import propTypes from "prop-types";
import {
  Chart as ChartJS,
  LinearScale,
  TimeScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  LineController,
  Legend,
  Tooltip,
} from "chart.js";
import { Chart } from "react-chartjs-2";
import zoomPlugin from "chartjs-plugin-zoom";

import "chartjs-adapter-moment";

ChartJS.register(
  LinearScale,
  LineController,
  TimeScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  zoomPlugin,
);

export const ChartData = ({ data, label, borderColor }) => {
  const datas = {
    datasets: [
      {
        type: "line",
        label,
        borderColor,
        borderWidth: 2,
        fill: false,
        data,
      },
    ],
  };

  const options = {
    scales: {
      y: {
        beginAtZero: true,
      },
      x: {
        type: "time",
        time: {
          displayFormats: {
            second: "DD/MM/YYYY HH:mm:ss",
            minute: "DD/MM/YYYY HH:mm:ss",
            hour: "DD/MM/YYYY HH:mm:ss",
            day: "DD/MM/YYYY HH:mm:ss",
            week: "DD/MM/YYYY HH:mm:ss",
            month: "DD/MM/YYYY HH:mm:ss",
            quarter: "DD/MM/YYYY HH:mm:ss",
            year: "DD/MM/YYYY HH:mm:ss",
          },
        },
      },
    },
    plugins: {
      zoom: {
        zoom: {
          wheel: {
            enabled: true, // SET SCROOL ZOOM TO TRUE
          },
          pinch: {
            enabled: true,
          },
          mode: "xy",
          speed: 100,
        },
        pan: {
          enabled: true,
          mode: "xy",
          speed: 100,
        },
      },
    },
  };

  return (
    <Chart
      type="line"
      options={options}
      data={datas}
    />
  );
};

ChartData.propTypes = {
  label: propTypes.string.isRequired,
  borderColor: propTypes.string.isRequired,
  data: propTypes.arrayOf(propTypes.any).isRequired,
};
